import React from 'react';
import { Icon } from 'semantic-ui-react';

import { STATUS } from '../hooks/useStartZoomSdk';

import css from './StatusJoinCall.less';

interface IStatusJoinCallProps {
  status: string;
}

const getTextFromStatus = (status: string) => {
  if (status === STATUS.joining) {
    return 'Initiating a call...';
  }
  if (status === STATUS.startingCameara) {
    return 'Starting camera...';
  }

  return 'Loading...';
};

function StatusJoinCall({ status }: IStatusJoinCallProps) {
  return (
    <div className={css.joiningContainer} id="joining-video-call">
      <div className={css.joiningContent}>
        <Icon loading name="spinner" />
        <div>{getTextFromStatus(status)}</div>
      </div>
    </div>
  );
}

export default StatusJoinCall;
